module.exports = __webpack_public_path__ + "static/7-d10848d8cb6a113269aeebc0a81a15d0.jpg";